import { render, staticRenderFns } from "./FormWizardIconTab-fie.vue?vue&type=template&id=6703bd4a&"
import script from "./FormWizardIconTab-fie.vue?vue&type=script&lang=js&"
export * from "./FormWizardIconTab-fie.vue?vue&type=script&lang=js&"
import style0 from "./FormWizardIconTab-fie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports